<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<label><input type="radio" :value="1" v-model="date_type_is_po" @change="dateTypeChanged()" />PO</label>
				<label><input type="radio" :value="2" v-model="date_type_is_po" @change="dateTypeChanged()" />Payment</label>
				<em class="lt_text"> Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="date_from"/> ~ <CustomDatePicker v-model="date_to"/></span>
				<span class="int_type_no_border mgr_5">
					<PartnerSelect ref="vendor" v-model="vendor_code" ph="Vendor" :showName="true" :initialName="vendor_name" :showFullName="false" :nameWidth="350" :nameClickToPopup="false" @set-partner="setPartner" />
				</span>
				<span v-if="false" class="int_type mgr_5">
					<input type="text" v-model.trim="check_no" placeholder="Enter Check No" autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
			<div class="left_option" style="margin-top:4px;">
				<button class="gray_bt" @click="openModal('Memo')"><font :color="partner.memo ? 'red' : 'black'">Memo</font></button>
				<!-- <em class="lt_text">Address</em><input type="text" class="tbl_int" style="width:300px;" :value="shipToAddressString()" readonly :title="shipToAddressString()" /> <em class="lt_text">Salesman</em
				><input type="text" class="tbl_int ssm2_int" :value="partner.sales_group_name" readonly />  -->

				<em class="lt_text">Phone</em><input type="text" class="tbl_int ssm2_int" :value="partner.telephone ? partner.telephone : partner.telephone2" readonly /> <em class="lt_text">Fax</em
				><input type="text" class="tbl_int sm_int" :value="partner.fax" readonly /> <em class="lt_text">Email</em><input type="text" class="tbl_int mm_int" :value="partner.email" readonly />
				<template v-if="partner.notice">
					<em class="lt_text"><font color="red">Notice</font></em
					><input type="text" class="tbl_int lm_int" style="color:red;" :value="partner.notice" readonly />
				</template>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big4_tbl" style="height:780px;">
				<div class="fixed-table-container mgb_10">
					<div class="table-wrapper">
						<table id="item_list" class="list_tbl tbl_pointer" border="0">
							<thead>
								<tr>
									<th style="text-align:center;width:7%"><div class="th-text">PO Date</div></th>
									<th style="text-align:center;width:8%;"><div class="th-text">PO No</div></th>
									<th style="text-align:center;width:12%;"><div class="th-text">Pay Term</div></th>
									<th style="text-align:center;width:7%;"><div class="th-text">PO Amt.</div></th>
									<th style="text-align:center;width:7%;"><div class="th-text">Balance</div></th>
									<th style="text-align:center;width:8%"><div class="th-text">Payment Date</div></th>
									<th style="text-align:center;width:9%;"><div class="th-text">Paid Amount</div></th>
									<th style="text-align:center;width:15%;"><div class="th-text">Check No</div></th>
									<th style="text-align:center;"><div class="th-text">Payment Remark</div></th>
								</tr>
							</thead>

							<tbody>
								<tr
									v-for="(po, index) in pos"
									v-bind:key="index"
									v-bind:class="{
										on: po.po_no == selectedPO.po_no && po.payment_no == selectedPO.payment_no,
										same: po.po_no != selectedPO.po_no && po.payment_no > 0 && po.payment_no == selectedPO.payment_no,
									}"
									@click="selectRow(po)"
								>
									<template v-if="index == 0 || (index > 0 && po.po_no != pos[index - 1].po_no)">
										<td>{{ po.po_date }}</td>
										<td @click.stop="">
											<a href="javascript:;" @click="selectPO(po)">{{ po.po_dn }}</a>
										</td>
										<td>{{ po.payment_term_name }}</td>

										<td style="text-align:right;">
											{{ po.po_amount | toCurrency }}
										</td>
										<td style="text-align:right;">
											<font :color="po.balance > 0 ? 'red' : 'black'">{{ po.balance | toCurrency }}</font>
										</td>
									</template>
									<template v-else>
										<td colspan="5"></td>
									</template>

									<template v-if="index == 0 || (index > 0 && po.payment_no != pos[index - 1].payment_no) || (index > 0 && po.payment_no != pos[index - 1].payment_no)">
										<td>{{ po.payment_date }}</td>
									</template>
									<template v-else><td></td></template>

									<td style="text-align:right;">
										<template v-if="po.po_count > 1 && po.method_count > 1">
											Not Applicable.
										</template>
										<template v-else>
											{{ po.pa_amount | toCurrency }}
											<span v-if="!po.payment_date && po.pa_amount" style="color:red;">(R)</span>
											<span v-else-if="po.reverse_yn == 'Y'">(R)</span>
										</template>
									</td>
									<td>
										{{ po.check_no }}
									</td>
									<td @click.stop="">
										{{ po.payment_remark }}
									</td>
								</tr>
								<tr>
									<td colspan="3" class="al_right">
										<font color="red">Total</font>
									</td>
									<td class="al_right">
										<font color="red">{{ pos_sum.po_amount | toCurrency }}</font>
									</td>
									<td class="al_right">
										<font color="red">{{ pos_sum.balance != 0 ? pos_sum.balance : null | toCurrency }}</font>
									</td>
									<td></td>
									<td class="al_right">
										<font color="red">{{ pos_sum.pa_amount != 0 ? pos_sum.pa_amount : null | toCurrency }}</font>
									</td>
									<td colspan="4"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="bottom_bt_box">
					<span class="al_left">Total Count : {{ pos_sum.po_count | commaSeparated }}</span>
				</div>
			</div>

			<div class="right_small4_tbl">
				<div>
					<h4 class="inner_h5">Associated Payments</h4>

					<table id="item_list" class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th style="text-align:center;width:22%;">Payment Date</th>
								<th style="text-align:center;">Check No / Info</th>
								<th style="text-align:center;width:30%;">Type</th>
								<th style="text-align:center;width:3%;">R</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(item, i) in paymentItems" v-bind:key="item.payment_item_no" v-bind:class="{ on: item.payment_no == selectedPaymentItem.payment_no }" @click="selectPaymentItem(item)">
								<td :rowspan="item.payment_item_count > 0 ? item.payment_item_count : 1" v-if="!i ? true : paymentItems[i - 1].payment_dn == paymentItems[i].payment_dn ? '' : true">{{ item.payment_date }}</td>
								<td class="truncate">{{ item.check_no }}</td>
								<td>{{ item.payment_type_name }}</td>
								<td :rowspan="item.payment_item_count > 0 ? item.payment_item_count : 1" v-if="!i ? true : paymentItems[i - 1].payment_dn == paymentItems[i].payment_dn ? '' : true">
									<template v-if="item.reverse_yn == 'Y'">
										<span style="font-weight:bold;color:red">&#10004;</span>
									</template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div>
					<h4 class="inner_h5">Associated POs</h4>
					<table id="item_list" class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th style="text-align:center;width:14%;">PO No</th>
								<th style="text-align:center;width:19%;">PO Date</th>
								<th style="text-align:center;width:14%">Vendor</th>
								<th style="text-align:center;">Name</th>
								<th style="text-align:center;width:15%;">PO Amt</th>
								<th style="text-align:center;width:15%;">Paid Amt</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="po in paymentPOs" v-bind:key="po.po_no">
								<td>
									<a href="javascript:;" @click="selectPO(po)">
										{{ po.po_dn }}
									</a>
								</td>
								<td>{{ po.po_date }}</td>
								<td>{{ po.vendor_code }}</td>
								<td class="truncate">{{ po.vendor_name }}</td>
								<td class="al_right">{{ po.po_amount | toCurrency }}</td>
								<td class="al_right">{{ po.amount | toCurrency }}</td>
							</tr>
							<tr>
								<td class="al_right" colspan="4"><font color="red">Total</font></td>
								<td class="al_right">
									<font color="red">{{ paymentPOs_po_total | toCurrency }}</font>
								</td>
								<td class="al_right">
									<font color="red">{{ paymentPOs_paid_total | toCurrency }}</font>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<MemoPopup :partner_code="partner.code" v-on:close="closeModal($event)" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
//import { apiSelectArHistory, apiSelectReceiptItemList, apiSelectReceiptInvoiceList, apiUpdateReceiptRemark } from '@/api/payment/index.js';
import { apiSelectApHistory, apiSelectPaymentItemList, apiSelectPaymentPOList } from '@/api/payment/index.js';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import Modal from '@/components/common/Modal';
import MemoPopup from '@/components/common/MemoPopup';
import '@/assets/css/table_box.css';
import { today, daysAgo } from '@/utils/date.js';
// import { apiGetBase64ReportTemplate, companyMrtUrl, objectCopy, PrintType, Report, reportMrtUrl, reportRender, objectToFormData } from '@/api/util';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'N',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			vendor_code: null,
			vendor_name: null,
			check_no: null,
			amount: null,

			date_type_is_po: '1',

			date_from: daysAgo(180),
			date_to: today(),

			pos: [],
			selectedPO: {},

			paymentItems: [],
			selectedPaymentItem: {},

			paymentPOs: [],

			paymentPOs_po_total: null,
			paymentPOs_paid_total: null,

			pos_sum: {},

			initial_po_no: null,

			partner: {},

			distinct_pos: [],

			modalName: '',
			showModal: false,

			default_ago_days: 180,

			clicked_po: {},
			// new_ar_memo: null,
			saveParam: '',

			payment_date: today(),
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		//Paging,
		// CodeSelect,
		Modal,
		MemoPopup,
		// ItemDetail,
		CustomDatePicker,
		PartnerSelect,
	},
	methods: {
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(rv) {
			this.showModal = false;
			if (rv) this.search();
		},
		shipToAddressString() {
			if (this.partner && Object.keys(this.partner).length > 0) return this.partner.address_detail + ', ' + this.partner.address_city + ', ' + this.partner.address_state + ' ' + this.partner.address_zipcode + ', ' + this.partner.country;
			else return '';
		},
		dateTypeChanged() {
			if (this.vendor_code) this.search();
		},
		selectPO(po) {
			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.uri, po_no: po.po_no } });
			window.open(routeData.href, 'herp_purchase_detail');
		},

		setPartner(partner) {
			this.vendor_name = partner.name;
			this.search();
		},
		search() {
			this.page_no = 1;
			this.selectPayments();
		},
		reset() {
			this.page_no = 1;
			this.vendor_code = null;
			this.vendor_name = null;
			this.check_no = null;
			this.amount = null;

			this.date_from = daysAgo(this.default_ago_days);
			this.date_to = today();

			this.payment_date = today();

			//this.$session.set('ar_history_uri', null);
		},
		async selectPayments() {
			if (!this.vendor_code) {
				this.$toast.error('Empty partner');
				return;
			}

			this.pos = [];
			this.selectedPO = {};
			this.paymentItems = [];
			this.selectedPaymentItem = {};
			this.paymentPOs = [];
			this.paymentPOs_po_total = 0;
			this.paymentPOs_paid_total = 0;
			this.distinct_pos = [];
			//this.ar_memo = null;

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				vendor_code: this.vendor_code,

				for_ap_history: true,
			};
			if (this.date_type_is_po == '1') {
				param.po_date_from = this.date_from;
				param.po_date_to = this.date_to;
			} else if (this.date_type_is_po == '2') {
				param.payment_date_from = this.date_from;
				param.payment_date_to = this.date_to;
			}
			//console.log(param);
			//this.saveParam = objectCopy(param);
			const { data } = await apiSelectApHistory(param);

			this.pos = data.apHistory;
			//console.log(this.pos);

			this.list_count = data.list_count;
			if (data.posSum) this.pos_sum = data.posSum;
			else this.pos_sum = {};

			if (data.partner) {
				this.partner = data.partner;
			} else {
				this.partner = {};
			}

			var uri = '/payment/ap_history?page_no=' + this.page_no;
			if (this.vendor_code) uri += '&vendor_code=' + this.vendor_code;
			if (this.vendor_name) uri += '&vendor_name=' + this.vendor_name;
			if (this.date_from) uri += '&date_from=' + this.date_from;
			if (this.date_to) uri += '&date_to=' + this.date_to;
			if (this.check_no) uri += '&check_no=' + this.check_no;
			if (this.amount) uri += '&amount=' + this.amount;
			if (this.date_type_is_po) uri += '&date_type_is_po=' + this.date_type_is_po;

			this.uri = uri;
			window.history.pushState({}, null, uri);
			this.$session.set('ap_history_uri', uri);

			if (this.initial_po_no) {
				var found = this.pos.filter(po => po.po_no == this.initial_po_no);
				// console.log(found);
				if (found.length > 0) this.selectRow(found[0]);

				this.initial_po_no = null;
			}
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectPayments();
		},
		async selectPaymentItem(item) {
			// console.log(item);
			this.selectedPaymentItem = item;

			const { data } = await apiSelectPaymentPOList({
				payment_no: item.payment_no,
			});
			//console.log(data);
			this.paymentPOs = data.paymentPOList;
			this.paymentPOs_po_total = 0;
			this.paymentPOs_paid_total = 0;
			this.paymentPOs.forEach(p => {
				this.paymentPOs_po_total += p.po_amount;
				this.paymentPOs_paid_total += p.amount;
			});
			//console.log(this.receiptInvoices);
		},
		selectRow(po) {
			this.selectedPO = po;
			this.selectedPaymentItem = {};
			this.paymentPOs = [];

			this.selectPaymentItems(po.po_no);
		},
		async selectPaymentItems(po_no) {
			//console.log(po_no);
			this.receiptInvoices = [];
			this.receiptInvoices_inv_total = null;
			this.receiptInvoices_paid_total = null;

			const { data } = await apiSelectPaymentItemList({
				po_no: po_no,
				including_deleted: true,
			});
			//console.log(data);
			this.paymentItems = data.paymentItemList;

			if (this.paymentItems.length == 1) {
				this.selectPaymentItem(this.paymentItems[0]);
			}
			//console.log(this.receiptItems);
		},
		async index() {},

		// agingList(arHistory) {
		// 	let a_30 = 0;
		// 	let a30_60 = 0;
		// 	let a60_90 = 0;
		// 	let a90_ = 0;

		// 	let list = [];
		// 	arHistory.forEach((i, index) => {
		// 		i.show = index === 0 || (index > 0 && i.invoice_no !== arHistory[index - 1].invoice_no);
		// 		let bool = false;
		// 		if (!i.receipt_date && i.ra_amount) {
		// 			bool = true;
		// 		}
		// 		if (i.reverse_yn === 'Y') bool = true;
		// 		i.r = bool;
		// 		i.receipt_remark_org = i.receipt_remark;
		// 		i.ar_memo_org = i.ar_memo;
		// 		if (list.filter(i2 => i2.invoice_no == i.invoice_no).length == 0) list.push({ invoice_no: i.invoice_no, aging_date: i.aging_date, ar_amount: i.balance + i.post_check_amount });
		// 	});
		// 	list.forEach(i => {
		// 		if (i.aging_date <= 30) a_30 += i.ar_amount;
		// 		else if (i.aging_date > 30 && i.aging_date <= 60) a30_60 += i.ar_amount;
		// 		else if (i.aging_date > 60 && i.aging_date <= 90) a60_90 += i.ar_amount;
		// 		else if (i.aging_date > 90) a90_ += i.ar_amount;
		// 	});

		// 	return { a_30: a_30, a30_60: a30_60, a60_90: a60_90, a90_: a90_ };
		// },

		// async arHistoryPrint() {
		// 	const { data } = await apiSelectArHistory(this.saveParam);

		// 	data.aging = this.agingList(data.arHistory);

		// 	await reportRender(data, 'ArHistory', reportMrtUrl('ArHistory'));
		// },
	},
	created() {
		this.$store.commit('setSideIndex', 4);
		this.$store.commit('setSelectedMenu', 'nav_li_ap_history');
		this.$store.commit('setSubTitle', 'Accouting -> AP History');

		if (this.$route.query.vendor_code) this.vendor_code = this.$route.query.vendor_code;
		if (this.$route.query.vendor_name) this.vendor_name = this.$route.query.vendor_name;
		// if (this.$route.query.date_from) this.date_from = this.$route.query.date_from;
		// if (this.$route.query.date_to) this.date_to = this.$route.query.date_to;
		// if (this.$route.query.check_no) this.check_no = this.$route.query.check_no;
		// if (this.$route.query.amount) this.amount = this.$route.query.amount;
		// if (this.$route.query.date_type_is_invoice) this.date_type_is_invoice = this.$route.query.date_type_is_invoice;
		// if (this.$route.query.invoice_no) this.initial_invoice_no = this.$route.query.invoice_no;

		if (this.$route.query.all_date) {
			this.date_from = null;
			this.date_to = null;
		} else {
			this.default_ago_days = 180;

			this.date_from = daysAgo(this.default_ago_days);
		}

		if (this.vendor_code) {
			this.selectPayments();
		}

		//this.index();
		//this.selectReceipts();
	},
	mounted() {
		inputSelectOnClick();

		this.$nextTick(function() {
			if (!this.vendor_code) this.$refs.vendor.$el.children[0].focus();
		});
	},
};
</script>

<style></style>
